import React from 'react';
import classnames from 'classnames';
import { isEmpty, get, head, find, isUndefined } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Typeahead } from 'modules/typeahead';
import { DATA_TYPES } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { typeAheadSearchField as TypeAheadSearchField } from 'ui/views/generic/typeAheadSearchField';
 *
 * // render
 * <TypeAheadSearchField propName='propValue'/>
 */
export const typeAheadSearchField = ( props ) => {

    // get error message (ref)
    const errorMessage = get( props.error, 'message', null );
    const hasError = ! isEmpty( errorMessage );

    // dynamic class name
    const widgetClassName = classnames( 'ui-type-ahead-search-field', props.className, {
        'ui-type-ahead-search-field--error': hasError,
    } );

    const labelClassName = classnames( 'ui-type-ahead-search-field__label', {
        'ui-type-ahead-search-field__label--no-label': false === props.label
    } );

    const selectClassName = classnames( 'ui-type-ahead-search-field__select', {
        'ui-type-ahead-search-field__select--no-label': false === props.label
    } );

    let placeholder = ! props.searchable ? getLabel( get( props, 'placeholder', 'Select' ) ) :  get( props, 'placeholder', 'Select' );
    if( ! isEmpty( props.value ) ) {

       const selectedOption = find( props.options, { value: props.value } );

       if( ! isUndefined( selectedOption ) ) {
           placeholder = getLabel( get( selectedOption, 'title', {} ) );
       }

    }
    
   return (
       <div className={ widgetClassName }>
           <div className='ui-type-ahead-search-field'>

               {/* label */}
               <div className={ labelClassName }>

                   {/* label text */}
                   <div className='ui-type-ahead-search-field__label__text'>{ getLabel( props.label ) }</div>

                   {/* required asterisk */}
                   {
                       props.required ? (
                           <div className='ui-type-ahead-search-field__label__asterisk'>*</div>
                       ) : null
                   }
               </div>

               {/* select */}
               <div className={ selectClassName }>
                   <Typeahead
                       allowFilter= { false }
                       placeholder={ placeholder  }
                       url={ props.url }
                       searchable= { true }
                       hideIcon = { props.hideIcon }
                       options= { props.options }
                       onChange={ ( { selected } ) => props.onChange( {
                           name: props.name,
                           value: props.searchType === DATA_TYPES.SINGLE_SELECT ? head( selected ) : selected,
                       } ) }
                       requestPayload= { props.requestPayload }
                       type= { props.searchType }
                   />
               </div>
           </div>

           {/* error message */}
           {
               hasError ? (
                   <div className='ui-type-ahead-search-field__error'>
                       <div className='ui-type-ahead-search-field__error__message'>
                           { getLabel( errorMessage ) }
                       </div>
                   </div>
               ) : null
           }
       </div>
   );
};

// set display name
typeAheadSearchField.displayName = 'typeAheadSearchField';

// set default props
typeAheadSearchField.defaultProps = {};

// prop types
typeAheadSearchField.propTypes = {};
